import type { ObjectId } from '@freightview/object-id'

import type { EquipmentType } from '../equipment/constants.ts'
import { vEquipmentType } from '../equipment/utils.ts'
import {
  vArray,
  vEmail,
  vMinLength,
  vObject,
  vObjectId,
  vOptional,
  type vOutput,
  vPicklist,
  vPipe,
  vString,
} from '../validation/index.ts'
import { type WorkflowMarkup, workflowMarkupSchema } from './account-user.ts'
import { type Workflow, workflows } from './common.ts'
import type { User } from './user.ts'

export const vendorPermissionTypes = ['view-rates', 'load-booker'] as const
export type VendorPermissionType = (typeof vendorPermissionTypes)[number]

export interface AccountVendor {
  _id: ObjectId
  created: Date
  name: string
  permissions: VendorPermissionType[]
  workflows: Workflow[]
  equipmentOptions?: EquipmentType[]
  markup?: WorkflowMarkup
  removed?: boolean
  removedDate?: Date
  removedBy?: ObjectId
}

export interface AccountVendorUser extends User {
  accountUserId: ObjectId
}

export interface VendorWithUsers extends AccountVendor {
  users: AccountVendorUser[]
}

export const upsertVendorSchema = vObject({
  name: vString(),
  equipmentOptions: vOptional(vArray(vEquipmentType('truckload'))),
  markup: vOptional(workflowMarkupSchema),
  permissions: vArray(vPicklist(vendorPermissionTypes)),
  users: vArray(vEmail),
  workflows: vPipe(
    vArray(vPicklist(workflows)),
    vMinLength(1, 'Vendor requires at least one mode'),
  ),
})
export type UpsertVendorRequest = vOutput<typeof upsertVendorSchema>

export const resendVendorInviteParamsSchema = vObject({
  id: vString(),
  userId: vString(),
})
export type ResendVendorInviteParams = vOutput<
  typeof resendVendorInviteParamsSchema
>

export interface VendorShipperAccount {
  _id: ObjectId
  name: string
}

export interface VendorSettingsResponse {
  shippers: VendorShipperAccount[]
  equipmentOptions: EquipmentType[]
}

export const updateVendorCurrentShipperSchema = vObject({
  _id: vObjectId(),
})
export type UpdateVendorCurrentShipperRequest = vOutput<
  typeof updateVendorCurrentShipperSchema
>
